module.exports = __webpack_public_path__ + "media/images/illustrations/flat_clip_payment-1ec6a3ad8dbb3c9bf541086cc4f92817.png";